
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.066.996H1.934c-.53 0-.989.193-1.375.58A1.843 1.843 0 000 2.93v12.89c0 .53.186.989.559 1.375.386.373.845.559 1.375.559h18.132c.53 0 .982-.186 1.354-.559.387-.386.58-.845.58-1.375V2.93c0-.53-.193-.981-.58-1.354a1.81 1.81 0 00-1.354-.58zm.645 14.824a.618.618 0 01-.193.451.618.618 0 01-.452.194H1.934a.618.618 0 01-.452-.194.618.618 0 01-.193-.45V2.93c0-.172.065-.323.193-.451a.618.618 0 01.452-.194h18.132c.172 0 .323.065.452.194.128.128.193.279.193.45V15.82zM9.518 5.637H3.115a.534.534 0 00-.386.172c-.1.1-.15.222-.15.365v6.402c0 .143.05.272.15.387.114.1.243.15.386.15h6.403c.157 0 .286-.05.386-.15.1-.115.15-.244.15-.387V6.174a.497.497 0 00-.15-.365.49.49 0 00-.386-.172zM8.98 6.71v5.027H3.652V6.711H8.98zm9.797-.602h-5.242a.618.618 0 00-.451.194.618.618 0 00-.193.45c0 .173.064.323.193.452s.28.193.451.193h5.242a.575.575 0 00.451-.193.618.618 0 00.194-.451.618.618 0 00-.194-.451.575.575 0 00-.45-.194zm0 2.579h-5.242-.021a.643.643 0 00-.473.193.658.658 0 00-.172.451c0 .172.057.322.172.451a.643.643 0 00.473.194h5.263a.575.575 0 00.451-.194.618.618 0 00.194-.451.618.618 0 00-.194-.451.575.575 0 00-.45-.194zm0 2.578h-5.242a.618.618 0 00-.451.193.618.618 0 00-.193.451c0 .172.064.322.193.451.129.13.28.194.451.194h5.242a.575.575 0 00.451-.194.618.618 0 00.194-.45.618.618 0 00-.194-.452.575.575 0 00-.45-.193z","fill":"currentColor"}})])
          )
        }
      }
    